export default __webpack_public_path__ + "static/media/appleStore.1420e6a2.png";